export enum SlateLayout {
  /** Layout has topbar and does not have sidebar */
  CLASSIC = 'CLASSIC',
  /** Layout has both topbar and sidebar */
  DEFAULT = 'DEFAULT',
  /** Layout does not have neither topbar nor sidebar */
  BASIC = 'BASIC',
  /** Layout does not have topbar and has sidebar */
  NO_HEADER = 'NO_HEADER',
}
